import { createRouter, createWebHistory } from 'vue-router';

import NotFound from '@lib/pages/NotFound.vue';

import lib_routes from '@lib/router';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			component: () => import('@lib/layouts/Dashboard/Main.vue'),
			meta: { auth: true },
			children: [
				{ path: '/', redirect: '/home' },
				{ path: 'home', name: 'Home', component: () => import('@/pages/Home.vue') },

				// User pages
				{
					path: 'tools',
					children: [
						{
							path: '/tools/decommission',
							name: 'Decommission',
							component: () => import('@/pages/tools/Decommission.vue'),
						},
						{
							path: '/tools/site-search',
							name: 'SiteSearcher',
							component: () => import('@/pages/tools/SiteSearch.vue'),
						},
						{
							path: '/tools/prepare-site',
							name: 'PrepareSite',
							component: () => import('@/pages/tools/PrepareSite.vue'),
						},
						{
							path: '/tools/prepare-site/history',
							name: 'PrepareSiteHistory',
							component: () => import('@/pages/tools/PrepareSiteHistory.vue'),
						},
					],
				},

				// Admin pages
				{ path: 'admin/users', component: () => import('@lib/pages/Admin/Users.vue') },
				{ path: 'admin/settings', component: () => import('@lib/pages/Admin/Settings/Settings.vue') },
				{ path: 'admin/maintenance', component: () => import('@lib/pages/Maintenance/Maintenance.vue') },

				// User profile pages
				{ path: 'me', name: 'Profile', component: () => import('@lib/pages/Me/Me.vue') },

				// Some default routes
				{
					// Fall-through to a 404 page
					path: ':pathMatch(.*)*',
					name: '404',
					component: NotFound,
				},
			],
		},
		...lib_routes,
	],
});

export default router;
